import { Component, Input } from '@angular/core';
import { PriorityValue } from '../../../../../../../Common/data/priority.value';
import { QuestionBasePriority } from '../../../../../../../Common/model/cwquestion';
import { ImageService } from '../../../../services/image/image.service';
import { DialogService } from '../../../dialog/service/dialog.service';

@Component({
  selector: 'app-show-row-question',
  templateUrl: './show-row-question.component.html',
  styleUrls: ['./show-row-question.component.scss'],
})
export class ShowRowQuestionComponent {
  PriorityValue = PriorityValue;
  @Input() cwQuestion: QuestionBasePriority;
  imageLoaded = false;
  imageFailedToLoad = false;
  constructor(
    private imageService: ImageService,
    private dialogService: DialogService,
  ) {}

  onShowLargeImage() {
    this.dialogService.showLargeImage(this.cwQuestion);
  }

  onImageLoaded() {
    this.imageLoaded = true;
  }

  onImageFailedToLoad() {
    this.imageFailedToLoad = true;
  }
}
